import { Flex } from '@chakra-ui/react';
import { useSearchParams } from 'react-router';
import FilterTag from '@components/FilterTag';

const SelectedFiltersList = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const name = searchParams.get('name');

  const onRemoveFilter = (key: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(key);
    setSearchParams(newParams);
  };

  return (
    <Flex gap={2}>
      {name && (
        <FilterTag
          label="Nome"
          value={name}
          onRemove={() => onRemoveFilter('name')}
        />
      )}
    </Flex>
  );
};

export default SelectedFiltersList;
